import { render } from "./FilePromptComponent.vue?vue&type=template&id=ac3b0e86&scoped=true"
import script from "./FilePromptComponent.vue?vue&type=script&lang=js"
export * from "./FilePromptComponent.vue?vue&type=script&lang=js"

import "./FilePromptComponent.vue?vue&type=style&index=0&id=ac3b0e86&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3b0e86"]])

export default __exports__